import Vue from 'vue'
Vue.filter('splitNumber', function (value) {
   return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
})
Vue.filter('getKNumber', function (number) {
   if (number < 1000) {
     return Math.round(number)
   }
   return Math.round(number / 1000) + " k"
})